var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7722 10.2287C21.311 9.92745 22.7588 9.51172 24 8.96098V12.7705C24 12.8386 23.9532 13.09 23.4244 13.4793C22.9163 13.8534 22.1171 14.2327 21.0401 14.5687C18.898 15.2369 15.878 15.6666 12.5 15.6666C9.12201 15.6666 6.10202 15.2369 3.95992 14.5687C2.88288 14.2327 2.08371 13.8534 1.57556 13.4793C1.04684 13.09 1 12.8386 1 12.7705V8.96098C2.24123 9.51173 3.68899 9.92745 5.22781 10.2287C7.47939 10.6694 9.99869 10.8789 12.5 10.8789C15.0013 10.8789 17.5206 10.6694 19.7722 10.2287Z",
    fill: "white",
    stroke: "#E86247",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 5.15872V3.17461C25 1.42609 19.4011 0 12.5 0C5.59894 0 0 1.42609 0 3.17461V5.15872C0 6.90725 5.59894 8.33333 12.5 8.33333C19.4011 8.33333 25 6.90725 25 5.15872ZM12.5002 2.08333C17.8106 2.08333 22.1155 2.5497 22.1155 3.125C22.1155 3.7003 17.8106 4.16667 12.5002 4.16667C7.18972 4.16667 2.88477 3.7003 2.88477 3.125C2.88477 2.5497 7.18972 2.08333 12.5002 2.08333Z",
    fill: "#C8C8C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 21.1039V15.625C22.3144 17.3904 17.3991 18.2123 12.5 18.2123C7.60089 18.2123 2.68555 17.3904 0 15.625V21.1039C0 23.2498 5.59894 25 12.5 25C19.4011 25 25 23.2498 25 21.1039ZM21.6347 21.875C22.4313 21.875 23.077 21.1754 23.077 20.3125C23.077 19.4496 22.4313 18.75 21.6347 18.75C20.8381 18.75 20.1924 19.4496 20.1924 20.3125C20.1924 21.1754 20.8381 21.875 21.6347 21.875Z",
    fill: "#C8C8C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseIcon);
export default __webpack_public_path__ + "static/media/database-icon.4e8a3a8685091581821caada0ad09ba3.svg";
export { ForwardRef as ReactComponent };